import { jsx } from "react/jsx-runtime";
import { Box, Tooltip } from "@mui/material";
import { FormFooter } from "../../../FormFooter.js";
import { LoginPrimaryAction } from "../../../LoginPrimaryAction/LoginPrimaryAction.js";
import { useAutoFocusEmptyField } from "../../hooks/useAutoFocusEmptyField.js";
import { loginForm } from "../../loginFormSetup.js";
import { useTexts } from "./useTexts.js";
function LoginFooter(props) {
  const {
    buttonProps,
    autoFocus: autofocusStatus,
    footerProps = {},
    showUid,
    showLoader,
    loaderColor = "#ffffff"
  } = props;
  const {
    meta: { submitting }
  } = loginForm.useFormMeta();
  const texts = useTexts();
  const autoFocusField = useAutoFocusEmptyField(autofocusStatus, showUid);
  const autoFocus = autoFocusField === "submit";
  return /* @__PURE__ */ jsx(FormFooter, { ...footerProps, children: /* @__PURE__ */ jsx(Tooltip, { title: texts.tooltip, children: /* @__PURE__ */ jsx(Box, { width: "100%", children: /* @__PURE__ */ jsx(
    LoginPrimaryAction,
    {
      label: texts.login,
      testId: "loginBtn",
      disabled: submitting,
      autoFocus,
      loading: showLoader && submitting,
      componentProps: { fullWidth: true, ...buttonProps },
      loaderColor
    }
  ) }) }) });
}
export {
  LoginFooter
};
//# sourceMappingURL=LoginFooter.js.map
